
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[communeSlug]",
      function () {
        return require("private-next-pages/[communeSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[communeSlug]"])
      });
    }
  